import { render, staticRenderFns } from "./EarningHistory.vue?vue&type=template&id=10a8534c&"
import script from "./EarningHistory.vue?vue&type=script&lang=js&"
export * from "./EarningHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports